// plugins/subscript-filter.js
import Vue from 'vue';

Vue.filter('supscriptTextAfterNumbers', function (value) {
  if (!value) return '';
  return value.replace(/(\d)([a-z]+)/gi, function(match, number, letters) {
      return number + "<sup>" + letters + "</sup>";
  });
});
